import { create } from "zustand";
import { Quest } from "@/constant/schema";

interface QuickScheduleParams {
  quest?: Quest;
  type?: string;
}

interface QuickScheduleState {
  params?: QuickScheduleParams;
  step: number;
  show: (step: number, params?: QuickScheduleParams) => void;
  hide: () => void;
  setStep: (step: number) => void;
  refreshTrigger: number;
  triggerRefresh: () => void;
}

export const useQuickScheduleStore = create<QuickScheduleState>((set) => ({
  params: undefined,
  step: 0,
  show: (step, params) => set({ step, params }),
  hide: () => set({ step: 0, params: undefined }),
  setStep: (step) => set({ step }),
  refreshTrigger: 0,
  triggerRefresh: () => set((state) => ({ refreshTrigger: state.refreshTrigger + 1 })),
}));